<template>
  <v-row no-gutters class="pa-3" align="center" justify="center">
    <v-container class="mx-auto">
      <div class="height-spacer"></div>
      <v-card-title class="containertext">
        <h1 id="text01pass" class="h36-medium white--text mr-2 mb-5">
          {{ $t("homepage.firstLogin.right.title") }}
        </h1>
        <h1 id="text01pass" class="h36-medium white--text mr-2 mb-5">
          {{ $t("homepage.firstLogin.right.title2") }}
        </h1>
        <h1 id="text01pass" class="h36-medium white--text mr-2 mb-5">
          {{ $t("homepage.firstLogin.right.title3") }}
        </h1>
      </v-card-title>

      <!-- FIRST LOGIN FORM -->
      <v-card-text>
        <v-form ref="loginForm" v-model="loginValid" lazy-validation>
          <v-text-field
            dark
            @blur="checkUsername"
            v-model="username"
            :label="$t('homepage.firstLogin.right.form.username.placeholder')"
            :hint="$t('homepage.firstLogin.right.form.username.hint')"
            :rules="[rules.required]"
            persistent-hint
            :error-messages="errorMessage"
          ></v-text-field>
          <v-text-field
            dark
            v-model="password"
            :label="$t('homepage.firstLogin.right.form.password')"
            :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
            :type="showPassword1 ? 'text' : 'password'"
            :rules="[rules.required, rules.passwordFormat]"
            :messages="passwordMessage"
            persistent-hint
            counter
            @click:append="showPassword1 = !showPassword1"
          ></v-text-field>
          <v-text-field
            dark
            v-model="confirm_password"
            :label="$t('homepage.firstLogin.right.form.confirm-password')"
            :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
            :type="showPassword2 ? 'text' : 'password'"
            :rules="[
              rules.required,
              rules.passwordMatch(
                password,
                confirm_password,
                $t('homepage.firstLogin.right.form.password')
              )
            ]"
            persistent-hint
            counter
            @click:append="showPassword2 = !showPassword2"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <!-- ACTIONS BUTTONS -->
      <v-card-actions id="actionbuttons" class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          rounded
          :disabled="!loginValid || isUsernameOccupied"
          @click="firstLogin"
          class="importantbutton"
        >
          <span class="font-weight-bold white--text">{{
            $t("homepage.firstLogin.right.btn")
          }}</span>
        </v-btn>
      </v-card-actions>

      <v-divider dark class="my-4 mx-3"></v-divider>

      <v-card-actions id="notregcard" class="pt-4 ml-2">
        <v-row no-gutters>
          <div
            id="notregscript"
            class="v-toolbar__title my-v-toolbar__title-inherit font-weight-light white--text"
          >
            {{ $t("homepage.firstLogin.right.not-register") }}
          </div>
          <v-btn
            id="tologinbtn"
            class="ml-1 mr-0 importantbutton"
            rounded
            @click="gotToLoginPage"
            >{{ $t("homepage.login.right.title") }}</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-container>
  </v-row>
</template>

<script>
import ValidationRules from "../../views/validationRules";

let vrules = new ValidationRules();

export default {
  components: {},
  data() {
    return {
      username: "",
      password: "",
      showPassword1: false,
      showPassword2: false,
      confirm_password: "",
      localRules: {
        passwordMatch: value =>
          value == this.password ||
          this.$t("homepage.firstLogin.right.form.error.confirm-password")
      },
      loginValid: true,
      rules: vrules,
      passwordMessage: this.$t("homepage.form.password-format")
    };
  },
  created() {},

  computed: {
    errorDialog() {
      return this.$store.getters["error/errorDialog"];
    },
    loadingDialog() {
      return this.$store.getters["loading/loadingDialog"];
    },
    isUsernameOccupied() {
      return this.$store.getters["auth/usernameAvailability"];
    },
    errorMessage() {
      return this.isUsernameOccupied
        ? this.$t("homepage.firstLogin.right.form.error.username-availability")
        : "";
    }
  },
  methods: {
    gotToLoginPage() {
      this.$router.push({ name: "login" });
    },
    checkUsername() {
      if (this.username) {
        this.$store.dispatch("auth/checkUsername", this.username);
      }
    },
    firstLogin() {
      let token = this.$route.params.token;
      if (!token) {
        throw new Error(`Missing user's token`);
      }
      this.$store.commit("auth/SET_FIRST_LOGIN_TOKEN", token);
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch("auth/firstLogin", {
          username: this.username,
          password: this.password
        });
      }
    },
    closeErrorDialog() {
      this.$store.commit("error/RESET");
    }
  }
};
</script>

<style scoped>
/*  Start Responsive screen + Specific Mobile & Tablets */

@media only screen and (min-width: 1527px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }
}

@media screen and (max-width: 1526px) and (min-width: 1524px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }
}

@media screen and (max-width: 1524px) and (min-width: 1513px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }
}

@media screen and (max-width: 1512px) and (min-width: 1509px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 95px !important;
    padding-right: 95px !important;
  }
}

@media screen and (max-width: 1508px) and (min-width: 1504px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1504px) and (min-width: 1500px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1499px) and (min-width: 1494px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1494px) and (min-width: 1480px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }
}

@media screen and (max-width: 1480px) and (min-width: 1477px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 85px !important;
    padding-right: 85px !important;
  }
}

@media screen and (max-width: 1477px) and (min-width: 1473px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 25px !important;
    padding-left: 85px !important;
    padding-right: 85px !important;
  }
}

@media screen and (max-width: 1472px) and (min-width: 1448px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 80px !important;
    padding-right: 80px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 1447px) and (min-width: 1404px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 80px !important;
    padding-right: 80px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1404px) and (min-width: 1380px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 75px !important;
    padding-right: 75px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1380px) and (min-width: 1350px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 70px !important;
    padding-right: 70px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1350px) and (min-width: 1300px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 20px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1300px) and (min-width: 1240px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 16px !important;
    padding-left: 53px !important;
    padding-right: 53px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1240px) and (min-width: 1200px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 12px !important;
    padding-left: 50px !important;
    padding-right: 50px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1200px) and (min-width: 1160px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 11px !important;
    padding-left: 42px !important;
    padding-right: 42px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1160px) and (min-width: 1100px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 9px !important;
    padding-left: 32px !important;
    padding-right: 32px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1100px) and (min-width: 1080px) {
  .importantbutton {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 8px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1080px) and (min-width: 1050px) {
  .importantbutton {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 8px !important;
    padding-left: 27px !important;
    padding-right: 27px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1050px) and (min-width: 1000px) {
  .importantbutton {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 7px !important;
    padding-left: 18px !important;
    padding-right: 18px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 1000px) and (min-width: 960px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 18px !important;
    margin-left: 6px !important;
    padding-left: 13px !important;
    padding-right: 13px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 959px) and (min-width: 614px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 150px !important;
    padding-right: 150px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 613px) and (min-width: 600px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 20px !important;
    padding-left: 130px !important;
    padding-right: 130px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 599px) and (min-width: 573px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 20px !important;
    padding-left: 120px !important;
    padding-right: 120px !important;
  }

  .containertext {
    width: 95%;
  }
}

@media screen and (max-width: 573px) and (min-width: 490px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 489px) and (min-width: 485px) {
  .importantbutton {
    padding-left: 80px !important;
    padding-right: 80px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 485px) and (min-width: 464px) {
  .importantbutton {
    padding-left: 145px !important;
    padding-right: 145px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 10px !important;
    padding-left: 80px !important;
    padding-right: 80px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 464px) and (min-width: 444px) {
  .importantbutton {
    padding-left: 135px !important;
    padding-right: 135px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 9px !important;
    padding-left: 70px !important;
    padding-right: 70px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 444px) and (min-width: 420px) {
  .importantbutton {
    padding-left: 130px !important;
    padding-right: 130px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 8px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 420px) and (min-width: 400px) {
  .importantbutton {
    padding-left: 110px !important;
    padding-right: 110px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 6px !important;
    padding-left: 45px !important;
    padding-right: 45px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 400px) and (min-width: 350px) {
  .importantbutton {
    padding-left: 90px !important;
    padding-right: 90px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 0px !important;
    margin-left: 5px !important;
    padding-left: 25px !important;
    padding-right: 25px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 349px) and (min-width: 316px) {
  .importantbutton {
    padding-left: 70px !important;
    padding-right: 70px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 90px !important;
    padding-right: 90px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 315px) and (min-width: 302px) {
  .importantbutton {
    padding-left: 60px !important;
    padding-right: 60px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 85px !important;
    padding-right: 85px !important;
  }

  .containertext {
    width: 90%;
  }
}

@media screen and (max-width: 301px) and (min-width: 280px) {
  .importantbutton {
    padding-left: 50px !important;
    padding-right: 50px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 75px !important;
    padding-right: 75px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 279px) and (min-width: 260px) {
  .importantbutton {
    padding-left: 40px !important;
    padding-right: 40px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 65px !important;
    padding-right: 65px !important;
  }

  .containertext {
    width: 100%;
  }
}

@media screen and (max-width: 260px) and (min-width: 240px) {
  .importantbutton {
    padding-left: 35px !important;
    padding-right: 35px !important;
    margin-left: 0px !important;
  }

  #notregscript {
    margin-top: 7px !important;
  }

  #tologinbtn {
    margin-bottom: 20px !important;
    margin-top: 20px !important;
    margin-left: 0px !important;
    padding-left: 60px !important;
    padding-right: 60px !important;
  }

  .containertext {
    width: 100%;
  }

  #text01pass {
    font-size: 30px !important;
  }
}
</style>
